import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const scrollToInfo = () => {
    const element = document.getElementById('que-incluye');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative flex items-center justify-center overflow-hidden pt-16 sm:pt-20 pb-2 sm:min-h-screen" data-id="element-97">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-98">
        <img src="https://cdn.magicpatterns.com/uploads/sYRmsDhAci3xVbnzQ1cXsF/20260301_1451_Clase_de_Literatura_simple_compose_01kjn8cv9je3892wc2se0nfk84.png" alt="Clase de Literatura" className="w-full h-full object-cover object-center scale-110 origin-center" style={{
        objectPosition: '50% 35%'
      }} data-id="element-99" />
        {/* Gradient Overlay: 70% opacity bottom -> 35% top */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/95 via-[#0a1628]/70 to-[#0a1628]/45" data-id="element-100"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-3 sm:px-6 text-center flex flex-col items-center" data-id="element-101">
        {/* Badge */}
        <div className="inline-block bg-[#fbbf24]/40 backdrop-blur-sm text-white font-semibold px-3 py-0.5 rounded-full text-[10px] sm:text-sm mb-0.5 border border-[#fbbf24]/50 text-center leading-tight" data-id="element-102">
          ⭐ El recurso #1 para docentes de Lengua y Literatura ⭐
        </div>

        {/* H1 Title */}
        <h1 className="text-[1.4rem] sm:text-4xl md:text-5xl lg:text-7xl font-extrabold text-white leading-none mb-0 drop-shadow-xl" data-id="element-103">
          Todo el año de Lengua y Literatura,
          <br className="hidden sm:block" data-id="element-104" /> listo para usar
        </h1>

        {/* Recursos Completos */}
        <p className="text-[#fbbf24] font-extrabold text-xl sm:text-3xl md:text-5xl lg:text-6xl leading-none mb-0 drop-shadow-xl mt-2" data-id="element-105">
          Recursos Completos
        </p>

        {/* Product Mockup */}
        <div className="w-full max-w-xs sm:max-w-lg md:max-w-xl mb-0 mt-4 cursor-pointer transform hover:scale-105 transition-transform duration-300" onClick={scrollToOffer} data-id="element-106">
          <img src="https://cdn.magicpatterns.com/uploads/er74i1V3KLcypFSAqyJ4jF/mockups_lenguA_.png" alt="Kit Completo Lengua y Literatura Mockup" className="w-full h-auto drop-shadow-2xl animate-float" data-id="element-107" />
        </div>

        {/* Subtitle */}
        <p className="text-sm sm:text-lg md:text-xl text-gray-200 max-w-2xl mx-auto mb-4 font-medium leading-snug drop-shadow-md" data-id="element-108">
          📚 Diseñado por docentes, para que ahorres meses de preparación y
          tengas tus clases listas para aplicar desde el primer día.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto mt-2" data-id="element-109">
          <button onClick={scrollToOffer} className="flex items-center justify-center bg-[#dc2626] hover:bg-red-700 text-white text-sm sm:text-lg font-bold py-3 px-6 sm:px-8 rounded-lg shadow-[0_4px_14px_0_rgba(220,38,38,0.39)] transition-all transform hover:-translate-y-1 w-full sm:w-auto border-b-4 border-red-900 active:border-b-0 active:translate-y-0" data-id="element-110">
            Adquirir Ahora <ArrowRight className="ml-2 h-5 w-5" data-id="element-111" />
          </button>

          <button onClick={scrollToInfo} className="flex items-center justify-center bg-transparent hover:bg-white/10 text-white border-2 border-white/30 text-sm sm:text-lg font-semibold py-3 px-6 sm:px-8 rounded-lg transition-all w-full sm:w-auto backdrop-blur-sm" data-id="element-112">
            Más Información
          </button>
        </div>
      </div>
    </section>;
}